import { formatBytes } from "../../MyHelpers";
import { IPayTableFactory } from "./IPayTableFactory";
import { PayTableAmatic } from "./PaytableAmatic";
import { PayTable, PaytablePerSymbol } from "./Paytable";
import { Size, Scale, CreateElement } from "../.././MyHelpers";
import { SlotSymbolSprite } from "../SlotSymbolSprite";

import { SlotSymbol } from "../SlotSymbol";
import { IGroupedSimplePaytableData, PayTable8Squares } from "./PayTable8Squares";
import { IPaytable } from "./IPayTable";
import { IPaytableParams } from "./IPayTableFactory";
import { PayTable9Squares } from "./PayTable9Squares";
export interface IPaytableData {
    Type: string | undefined;
    Template: string | undefined;
    PaytableForBetCredits: number;
}

export interface ISimplePaytableData extends IPaytableData {
    Pays: PaytablePerSymbol[];
}



export class PayTableFactory implements IPayTableFactory {


    public CreatePayTable(paytableParams: IPaytableParams): IPaytable {        
        if (paytableParams.paytable.Type == "SimplePaytable") {
            let SimplePaytableData = paytableParams.paytable as ISimplePaytableData;
            return new PayTable(SimplePaytableData.Pays, paytableParams);
        }
        else if (paytableParams.paytable.Type == "GroupedSimplePaytable") {
            let GroupedSimplePaytableData = paytableParams.paytable as IGroupedSimplePaytableData;
            if (paytableParams.paytable.Template == "PayTable8Squares") {
                return new PayTable8Squares(GroupedSimplePaytableData, paytableParams);
            }
            else if (paytableParams.paytable.Template == "PayTable9Squares") {
                return new PayTable9Squares(GroupedSimplePaytableData, paytableParams);
            }
        }

        throw `Paytable type ${paytableParams.paytable.Type} not implemented (missing in Paytable factory)`;
    }

}